// Descendant-selector rules that style the elements produced by
// `parseFormattedContent` (the `.ai-*` classes). Kept as a standalone export so
// any surface rendering assistant markdown — the chat bubble and the AI
// Activity step "Final output" pane — shares one source of truth.
export const markdownContentStyles = {
  '& .ai-paragraph': {
    margin: 0,
    lineHeight: 1.45,
  },
  '& .ai-paragraph + .ai-paragraph': {
    marginTop: '12px',
  },
  '& .ai-citation-card + .ai-citation-description': {
    marginTop: '8px',
  },
  '& .ai-section-header': {
    display: 'block',
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: 1.4,
    margin: 0,
    marginTop: '16px',
    marginBottom: '8px',
  },
  '& .ai-paragraph + .ai-section-header': {
    marginTop: '16px',
  },
  '& .ai-list': {
    margin: 0,
    paddingLeft: '20px',
  },
  '& .ai-paragraph + .ai-list, & .ai-section-header + .ai-list': {
    marginTop: '8px',
  },
};
